<table mat-table [dataSource]="parcels" class="parcel-list">
    <ng-container matColumnDef="height">
        <th mat-header-cell *matHeaderCellDef>Height</th>
        <td mat-cell *matCellDef="let parcel"> {{parcel.height}} cm </td>
    </ng-container>
    <ng-container matColumnDef="length">
        <th mat-header-cell *matHeaderCellDef>Length</th>
        <td mat-cell *matCellDef="let parcel"> {{parcel.length}} cm </td>
    </ng-container>

    <ng-container matColumnDef="width">
        <th mat-header-cell *matHeaderCellDef>Width</th>
        <td mat-cell *matCellDef="let parcel"> {{ parcel.width }} cm </td>
    </ng-container>

    <ng-container matColumnDef="mass">
        <th mat-header-cell *matHeaderCellDef>Mass</th>
        <td mat-cell *matCellDef="let parcel"> {{ getMass(parcel) }} kg </td>
    </ng-container>

    <ng-container matColumnDef="parcel_count">
        <th mat-header-cell *matHeaderCellDef>Parcel count</th>
        <td mat-cell *matCellDef="let parcel">
            {{parcel.parcelCount}}
        </td>
    </ng-container>

    <ng-container matColumnDef="parcel_number">
        <th mat-header-cell *matHeaderCellDef>Parcel number</th>
        <td mat-cell *matCellDef="let parcel"> {{parcel.parcelNo ? parcel.parcelNo : "-"}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let parcel"> {{parcel.parcelDescription ? parcel.parcelDescription : "-"}} </td>
    </ng-container>

    <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let parcel">
            <button *ngIf="!capturing" (click)="deleteParcel(parcel)" mat-stroked-button>
                <mat-icon>delete_outline</mat-icon> Remove
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
